'use client'

import { useEffect } from 'react'
import { xPixel } from '../client'

type XPixelPurchaseProps = {
  eventId: string
  value: number
  currency?: string
  contents?: Array<{
    content_type?: string
    content_id?: string
    content_name?: string
    content_price?: number
    num_items?: number
    content_group_id?: string
  }>
  conversionId: string
  emailAddress?: string
}

export function XPixelPurchase({
  eventId,
  value,
  currency = 'USD',
  contents,
  conversionId,
  emailAddress,
}: XPixelPurchaseProps) {
  useEffect(() => {
    xPixel(eventId, {
      value,
      currency,
      contents,
      conversion_id: conversionId,
      email_address: emailAddress,
    })
  }, [eventId, value, currency, contents, conversionId, emailAddress])

  return null
}
